import { render } from "./ProductsListView.vue?vue&type=template&id=90d87450&ts=true"
import script from "./ProductsListView.vue?vue&type=script&lang=ts"
export * from "./ProductsListView.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Build\\TCF\\ABBp_PIS\\6.14\\PisNextGenExtProd-PisApp_6_14_0\\PisNextGenExtProd\\PisNextGen\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__